module.exports = __webpack_public_path__ + "images/f2b86d3242d958b9e0e696e1eb380649.webp";